export default {
  namespaced: true, // 开启命名空间
  state: {
    menu: [],
    navList: [],
    activeKey: "",
    currentNav: "",
  },
  mutations: {
    setMenu(state, data) {
      state.menu = data;
    },
    setActiveKey(state, data) {
      state.activeKey = data;
    },
    setNavList(state, data) {
      state.navList = data;
    },
    setCurrentNav(state, data) {
      state.currentNav = data;
    },
  },
  actions: {},
  getters: {
    menu: (state) => state.menu,
    activeKey: (state) => state.activeKey,
    navList: (state) => state.navList,
    currentNav: (state) => state.currentNav,
  },
};
